module.exports = __webpack_public_path__ + "static/media/telegram.f16c3c2b.png";